import md5 from 'js-md5';
var CryptoJS = require("crypto-js");
const secretKey = "2907240577C02F1E";
export function hasClass(el, className) {
    let reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
    return reg.test(el.className)
}



//判断值是否为null或者undefind
export function val_empty(zhi) {
    if (zhi == null || typeof zhi == "undefined" || zhi == '') {
        return false;
    } else if ((typeof zhi === "undefined" ? "undefined" : _typeof(zhi)) == "object") {
        return true;
    } else {
        return true;
    }
}

//获取时间戳20170626164644864，就是这种类型
export function NowTimeCode() {
    var Result = "";

    var now = new Date();

    var year = now.getYear();

    if (now.getYear() < 1900) {
        year = now.getYear() + 1900;
    }

    var month = now.getMonth() + 1;
    var day = now.getDate();
    var hour = now.getHours();
    var minutes = now.getMinutes();
    var second = now.getSeconds();
    var millisecond = now.getMilliseconds();

    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    if (hour < 10) hour = "0" + hour;
    if (minutes < 10) minutes = "0" + minutes;
    if (second < 10) second = "0" + second;

    if (millisecond < 10) millisecond = "00" + millisecond; else {
        if (millisecond < 100) {
            millisecond = "0" + millisecond;
        }
    }

    Result = year.toString() + month.toString() + day.toString() + hour.toString() + minutes.toString() + second.toString() + millisecond.toString();

    return Result;
}


//获取当前日期
export function getNowDate() {
    var lianjie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '-';

    var now = new Date();
    var month = now.getMonth() + 1;
    if (month < 10) {
        month = "0" + month;
    }
    var day = now.getDate();
    if (day < 10) {
        day = "0" + day;
    }
    return now.getFullYear() + lianjie + month + lianjie + day;
}

export function getNowFormatDate(date) {
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
}

/**
   * 设置cookie方法
   * @param   {string}  c_name  cookie键值
   * @param   {string}  value  cookie值
   * @param   {Boolean}  domain  判断是否需要跨域
   * @return  {*}  返回cookie值
   */
export function setCookie(name, value, domain) {
    var exdate = new Date(), expiredays = 365;
    exdate.setDate(exdate.getDate() + expiredays);
    //判断是否需要跨域存储
    if (domain) {
        document.cookie = name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/;domain=suhuishou.com";
        document.cookie = name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
    } else {
        document.cookie = name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
    }
}
/**
 * 获取cookie方法
 * @param   {string}  name  cookie键值
 * @return  {*}  返回cookie值
 */
export function getCookie(name) {
    if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(name + "=");
        if (start != -1) {
            start = start + name.length + 1;
            var end = document.cookie.indexOf(";", start);
            if (end == -1) {
                end = document.cookie.length;
            }
            return unescape(document.cookie.substring(start, end));
        }
    }
}
/**代码加密*/
export function encrypt(value) {

    return CryptoJS.DES.encrypt(
        value,
        CryptoJS.enc.Utf8.parse(secretKey),
        {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }
    ).toString();
}
export function decrypt(encryptstr) {
    return CryptoJS.DES.decrypt(
        encryptstr,
        CryptoJS.enc.Utf8.parse(secretKey),
        {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }
    ).toString(CryptoJS.enc.Utf8);
}